import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { BeautybookService } from '@features/beautybook/services/beautybook.service';
import { Product } from '@features/product/interfaces/product.interface';
import { ProductService } from '@features/product/services/product.service';
import {
  faChevronRight,
  faComment,
  faHeart,
  faShare,
} from '@fortawesome/free-solid-svg-icons';
import {
  DataListParameter,
  ProductDataListParameter,
} from '@shared/interfaces/data-list-parameter.interface';
import { combineLatest, map, mergeMap, Subject, takeUntil } from 'rxjs';
import { LayoutService } from 'src/app/layout/services/layout.service';
import SwiperCore, { Navigation, SwiperOptions } from 'swiper';
import { Banner } from './interfaces/banner';
import { BannerService } from './services/banner.service';

SwiperCore.use([Navigation]);
@Component({
  selector: 'fc-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  config: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 5,
    speed: 300,
    loop: true,
    loopedSlides: 2,
    autoplay: {
      delay: 5000,
    },
    navigation: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        speed: 900,
        centeredSlides: true,
        spaceBetween: 0,
        slideToClickedSlide: true,
      },
    },
  };
  productConfig: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 12,
    loop: false,
    loopedSlides: 1,
    freeMode: true,
    breakpoints: {
      640: {
        slidesPerView: 4,
      },
    },
  };

  faChevronRight = faChevronRight;
  faHeart = faHeart;
  faComment = faComment;
  faShare = faShare;

  loading = true;
  banners: Banner[] = [];
  bestSellerProducts: Product[] = [];
  newArrivalProducts: Product[] = [];
  beautybookPosts: any = [];
  saleProducts: Product[] = [];

  constructor(
    private bannerService: BannerService,
    private layoutService: LayoutService,
    private productService: ProductService,
    private beautybookService: BeautybookService
  ) {
    this.layoutService.setShowPromotion(true);
  }

  // lifecycle hooks
  ngOnInit(): void {
    this.layoutService.isMobile$
      .pipe(
        map((isMobile: boolean) => {
          return isMobile;
        }),
        mergeMap((isMobile: boolean) => {
          const banners = isMobile
            ? this.bannerService.getMobileBanners()
            : this.bannerService.getBanners();

          const bestSellerProducts = this.productService.getBestSellerProducts(
            5,
            1
          );

          const newArrivalParam: ProductDataListParameter = {
            item_per_page: 12,
            current_page: 1,
            sorts: [{ field: 'id', direction: 'desc' }],
          };
          const newArrivalProducts =
            this.productService.getProducts(newArrivalParam);

          const beautybookPostParam: DataListParameter = {
            item_per_page: 12,
            current_page: 1,
            sorts: [{ field: 'id', direction: 'desc' }],
          };
          const beautybookPosts =
            this.beautybookService.getBeautybookPosts(beautybookPostParam);

          const saleParam: ProductDataListParameter = {
            item_per_page: 6,
            current_page: Math.floor(Math.random() * 3 + 1),
            sale: true,
          };
          const saleProducts = this.productService.getProducts(saleParam);

          return combineLatest([
            banners,
            bestSellerProducts,
            newArrivalProducts,
            beautybookPosts,
            saleProducts,
          ]);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(
        ([
          banners,
          bestSellerProducts,
          newArrivalProducts,
          beautybookPosts,
          saleProducts,
        ]) => {
          this.banners = banners;
          this.bestSellerProducts = bestSellerProducts;
          this.newArrivalProducts = newArrivalProducts.products;
          this.beautybookPosts = beautybookPosts;
          this.saleProducts = saleProducts.products;

          this.loading = false;
        }
      );
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.layoutService.setShowPromotion(false);
  }
}
